var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitterDesktopMessage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 13,
  viewBox: "0 0 15 13",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2.073 11.917h10.854q.405 0 .677-.263a.87.87 0 0 0 .272-.651V3.775L8.448 7.262q-.438.27-.948.27t-.948-.27L1.124 3.775v7.228q0 .39.272.651a.94.94 0 0 0 .677.263M12.927 1.083H2.073a.95.95 0 0 0-.668.263.84.84 0 0 0-.28.634v.525l6.041 3.86q.317.22.668.017l6.042-3.877V1.98a.84.84 0 0 0-.281-.634.95.95 0 0 0-.668-.263M2.073 0h10.854q.861 0 1.467.576Q15 1.15 15 1.98v9.023a1.9 1.9 0 0 1-.606 1.413q-.606.585-1.467.584H2.073a2.04 2.04 0 0 1-1.467-.584A1.9 1.9 0 0 1 0 11.003V1.98Q0 1.152.606.576A2.05 2.05 0 0 1 2.073 0"
})));
export default SvgTwitterDesktopMessage;